import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../services/auth.service';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonComponent } from '../button/button.component';
import { InputComponent } from '../input/input.component';
import { CommonService } from '../../services/common.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-reset-password',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, RouterModule, ButtonComponent, InputComponent, TranslateModule],
  templateUrl: './reset-password.component.html',
  styleUrl: './reset-password.component.scss'
})
export class ResetPasswordComponent {
  
  resetPasswordForm = new FormGroup({
    newPassword: new FormControl('', [Validators.required, Validators.minLength(6)]),
    confirmPassword: new FormControl('', [Validators.required])
  });
  token: string|null = null;
  isLoading = false;
  errorMessage = '';
  successMessage = '';
  isSuccess = false;

  constructor(
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService
  ) {}

  ngOnInit(){
    this.resetPasswordForm.get('newPassword')?.valueChanges.subscribe(() => {
      this.checkPasswords()
    });
    this.resetPasswordForm.get('confirmPassword')?.valueChanges.subscribe(() => {
      this.checkPasswords()
    });
    this.route.queryParamMap.subscribe(params => {
      const token = params.get('token');
      if(!token){
        this.router.navigate([''])
      }
      this.token = token
    });
  }

  onSubmit() {
    this.resetPasswordForm.markAllAsTouched();
    this.commonService.markFormGroupDirty(this.resetPasswordForm)
    if (this.resetPasswordForm.valid && this.token) {
      const { newPassword, confirmPassword } = this.resetPasswordForm.value;
      
      if(!newPassword || !confirmPassword) return
      if(newPassword != confirmPassword){
        return
      }


      this.isLoading = true;
      this.errorMessage = '';
      this.successMessage = '';

      this.authService.resetPassword(this.token, newPassword).subscribe(
        (response) => {
          this.isLoading = false;
          this.successMessage = 'Se ha reseteado la contraseña exitosamente.';
          this.isSuccess = true;
          this.resetPasswordForm.reset();
        },
        (error) => {
          console.error('Error al solicitar recuperación de contraseña:', error);
          this.isLoading = false;
          this.errorMessage = error.error.message;
        }
      );
    }
  }

  checkPasswords(): void {
    const group = this.resetPasswordForm
    const passwordControl = group.get('newPassword');
    const confirmPasswordControl = group.get('confirmPassword');
  
    if (passwordControl && confirmPasswordControl) {
      const pass = passwordControl.value;
      const confirmPass = confirmPasswordControl.value;
  
      if (pass !== confirmPass) {
        confirmPasswordControl.setErrors({ notSame: true });
      } else {
        confirmPasswordControl.setErrors(null);
      }
    }
  }
}